import { AssociationStatus } from './association-status';

export class Association {
  id?: number;
  candidateId: number;
  reqId: number;
  status?: string;
  subStatus?: string;
  externalStatus?: string;
  associationStatuses: AssociationStatus[] = [];
  createdDate?: string;
  createdByName?: string;
  createdById?: number;
  lastModifiedDate?: Date;
  lastModifiedByName?: string;
  currentExternalStage: string;
  // fields use for automatic note creation, used only on front-end, ignored by backend
  noteComment?: string;
  hasNote: boolean;
  internal: boolean;
  appliedAt?: string;

  constructor(candidateId: number, reqId: number) {
    this.candidateId = candidateId;
    this.reqId = reqId;
    this.associationStatuses = [];
  }
}

export interface AssociationFilter {
  offset: number;
}

export const associationDefaultFilter: AssociationFilter = {
  offset: 0,
};
